// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"fc0349bd","453":"5bb12c6b"}[chunkId] + ".chunk.js";
};